module.exports = __webpack_public_path__ + "img/slide12.2c1edc42.png";